module.exports = __webpack_public_path__ + "img/news1.b85b6ee1.jpeg";